import { useParams } from "react-router";
import { PageCanvas } from "../../../layouts/PageCanvas";
import { PageContainer } from "../../../layouts/PageContainer";
import { PageHeader } from "../../../layouts/PageHeader";
import useReadCohort from "../../../services/api/cohorts/queries/useReadCohort";
import CohortContainer from "./CohortContainer";

const PageCohort = () => {
  const { cohortId } = useParams();

  const {
    data: dataCohort,
    isLoading: isLoadingCohort,
    isError: isErrorCohort,
  } = useReadCohort(cohortId);
  // const [isStarred, setIsStarred] = React.useState(false);

  return (
    <PageContainer>
      <PageHeader
        isLoading={isLoadingCohort}
        isError={isErrorCohort}
        back={{ title: "Cohorts", to: "/app/cohorts" }}
        title={`${dataCohort?.title}`}
        isIncludeProfile={true}
      ></PageHeader>
      <PageCanvas>
        {cohortId && <CohortContainer cohortId={cohortId}></CohortContainer>}
      </PageCanvas>
    </PageContainer>
  );
};

export default PageCohort;
